import type { Icon } from "iconsax-react";
import {
  Brush,
  Colorfilter,
  Gift,
  Health,
  MagicStar,
  Sun1,
  Wind,
} from "iconsax-react";
import type { ReactElement } from "react";
import { createElement } from "react";

export type ProductIconId =
  | "bottle"
  | "cosmetic"
  | "masks"
  | "sun"
  | "lipstick"
  | "perfume"
  | "pallete"
  | "gift";

type ProductIconDefinition = {
  id: ProductIconId;
  label: string;
  Icon: Icon;
};

export const PRODUCT_ICON_OPTIONS: ProductIconDefinition[] = [
  { id: "bottle", label: "سرم / شیشه", Icon: Health },
  { id: "cosmetic", label: "کرم", Icon: Brush },
  { id: "masks", label: "ماسک", Icon: MagicStar },
  { id: "sun", label: "ضدآفتاب", Icon: Sun1 },
  { id: "lipstick", label: "آرایشی", Icon: Brush },
  { id: "perfume", label: "عطر", Icon: Wind },
  { id: "pallete", label: "پالت", Icon: Colorfilter },
  { id: "gift", label: "هدیه", Icon: Gift },
];

export const DEFAULT_PRODUCT_ICON_ID: ProductIconId = "bottle";

export function getProductIconById(iconId: ProductIconId): ProductIconDefinition {
  return PRODUCT_ICON_OPTIONS.find((option) => option.id === iconId) ?? PRODUCT_ICON_OPTIONS[0];
}

export function renderProductIcon(iconId: ProductIconId, size: number, color: string): ReactElement {
  const definition = getProductIconById(iconId);
  return createElement(definition.Icon, {
    size,
    variant: "Bold",
    color,
  });
}
